// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"42684906","229":"b089a66e","295":"6ce09388","394":"0e35f0be","530":"94097426","590":"0de0ea56","591":"9acdfc9e","779":"31ec878a","794":"3d78f8ef","926":"ce623510"}[chunkId] + ".chunk.js";
};